export default __webpack_public_path__ + "static/media/stella_blue.653b095f.png";